import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { generateHexId } from '../../../shared/utils/utils'
import { ServiceAdditionalProposalFormComponent } from './service-additional-proposal-form/service-additional-proposal-form.component'
import { JsonPipe } from '@angular/common'
import { MatTooltip } from '@angular/material/tooltip'

@Component({
  selector: 'service-additional-proposal-create',
  imports: [
    MatInputModule,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIcon,
    MatPaginator,
    MatRow,
    MatTable,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatTable,
    ServiceAdditionalProposalFormComponent,
    JsonPipe,
    MatTooltip,
  ],
  templateUrl: './service-additional-proposal-create.component.html',
  styleUrl: './service-additional-proposal-create.component.scss',
  providers: [],
  standalone: true,
})
export class ServiceAdditionalProposalCreateComponent
  implements OnInit, AfterViewInit
{
  constructor() {}

  item: any = {}
  itemsList: any[] = []

  @Input() period: any = {
    dataInicio: '',
    dataFim: '',
    dataInicioDescription: '',
    dataFimDescription: '',
  }
  @Output() response: EventEmitter<any> = new EventEmitter()
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    {
      keyColumn: 'description',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'priceUnit',
      key: 'priceUnit_formatted',
      description: 'Valor Unitário',
    },
    {
      keyColumn: 'amount',
      key: 'amount',
      description: 'Quantidade',
    },
    {
      keyColumn: 'tax',
      key: 'tax_formatted',
      description: 'Taxa',
    },
    {
      keyColumn: 'date',
      key: 'date_formatted',
      description: 'Data',
    },
    {
      keyColumn: 'priceTotal',
      key: 'priceTotal_formatted',
      description: 'Valor Total',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true, duplicate: true },
      description: 'Ações',
    },
  ]
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  displayedColumns: string[] = [
    'description',
    'priceUnit',
    'amount',
    'tax',
    'priceTotal',
    'date',
    'action',
  ]

  ngOnInit(): void {
    this.tableSource = new MatTableDataSource<any>(this.itemsList)
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    if (this.table) {
      this.table.renderRows()
    }
  }

  responseForm(element: any) {
    switch (element.action) {
      case 'create':
        this.includeItem(element.item)
        return
      case 'edit':
        this.updateItem(element.item)
        return
      case 'delete':
        this.deleteItemEvent(element.index)
        return
      case 'cancel':
        this.item = {}
        return
    }
  }

  generateId() {
    let id = generateHexId()
    if (this.itemsList.length == 0) {
      return id
    } else {
      let idDistinct = false
      while (!idDistinct) {
        if (
          this.itemsList.findIndex((ele: any) => {
            return ele.idCreate == id
          }) == -1
        ) {
          idDistinct = true
        } else {
          id = generateHexId()
        }
      }
      return id
    }
  }

  includeItem(element: any) {
    this.itemsList.push({ ...element, idCreate: this.generateId() })
    this.tableSource = new MatTableDataSource<any>(this.itemsList)
    this.refreshTable()
    this.response.emit(this.itemsList)
  }

  updateItem(element: any) {
    let index = this.itemsList.findIndex((ele: any) => {
      return ele.idCreate == element.idCreate
    })
    this.itemsList.splice(index, 1, (({ index, ...rest }) => rest)(element))
    this.tableSource = new MatTableDataSource<any>(this.itemsList)
    this.refreshTable()
    this.item = {}
    this.response.emit(this.itemsList)
  }

  deleteItemEvent(element: any) {
    let index = this.itemsList.findIndex((ele: any) => {
      return ele.idCreate == element.idCreate
    })
    if (index >= 0) {
      this.itemsList.splice(index, 1)
      this.tableSource = new MatTableDataSource<any>(this.itemsList)
      this.refreshTable()
      this.response.emit(this.itemsList)
    }
  }

  duplicateItem(element: any) {
    let index = this.itemsList.findIndex((ele: any) => {
      return ele.idCreate == element.idCreate
    })
    let newItem = { ...element, idCreate: this.generateId() }
    this.itemsList.splice(index, 0, newItem)
    this.tableSource = new MatTableDataSource<any>(this.itemsList)
    this.refreshTable()
    this.response.emit(this.itemsList)
  }

  selectItemEvent(element: any) {
    this.item = element
  }

  checkdate(date: any) {
    if (
      this.period &&
      date != '' &&
      this.period.dataFimDescription != '' &&
      this.period.dataInicioDescription
    ) {
      const endParsed = new Date(
        this.period.dataFim.split('/').reverse().join('-'),
      )
      const startParsed = new Date(
        this.period.dataInicio.split('/').reverse().join('-'),
      )
      const dateParsed = new Date(date.split('/').reverse().join('-'))
      if (startParsed <= dateParsed && dateParsed <= endParsed) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }
}
